import { render, staticRenderFns } from "./AssumeTenantBtn.vue?vue&type=template&id=36be756e&"
import script from "./AssumeTenantBtn.vue?vue&type=script&lang=js&"
export * from "./AssumeTenantBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports